"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilterContent = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _react = require("react");
var _FilterTypes = require("../components/Filters/FilterTypes");
var _actions = require("../redux/actions");
var _selectors = require("../redux/selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useFilterContent = _ref => {
  let {
    config,
    activeFilterIds,
    objectId
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  const data = (0, _reactRedux.useSelector)(_selectors.selectDevicesDataByPwhC, (prev, next) => {
    if (prev.length === 0 && next.length === 0) return true;
    if (prev.length !== next.length) return false;
    const keys = Object.keys(prev);
    /** check equal only id in data */
    return keys.every(key => prev[key][objectId] === next[key][objectId]);
  });
  (0, _react.useEffect)(() => {
    if (!activeFilterIds.length) {
      dispatch((0, _actions.setFilteredIdList)(data.map(item => item[objectId])));
      return;
    }
    const activeValues = activeFilterIds.reduce((acc, activeFilterId) => {
      const activeFilter = config.find(configFilter => configFilter.id === activeFilterId);
      return [...acc, ...activeFilter.value];
    }, []);
    /** custom functions */
    const filteredDataIds = data.reduce((acc, item) => {
      const include = activeValues.includes(item.equipmentType);
      return include ? [...acc, item[objectId]] : acc;
    }, []);
    dispatch((0, _actions.setFilteredIdList)(filteredDataIds));
  }, [config, activeFilterIds, dispatch, data, objectId]);
};
exports.useFilterContent = useFilterContent;
useFilterContent.propTypes = {
  config: _FilterTypes.ConfigType.isRequired,
  activeFilterIds: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  objectId: _propTypes.default.string
};
useFilterContent.defaultProps = {
  objectId: 'id'
};